export default function Datos() {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen p-10 bg-dark-primary">
      {/* Encabezado */}
      <div className="text-center mb-10 max-w-4xl">
        <h1 className="text-white text-4xl lg:text-5xl mb-4 lg:mb-14">
          ¿Por qué elegir <span className="text-[#ea1300]">Karggu</span>?
        </h1>
        <p className="text-white font-light text-lg lg:text-[1.3vw]">
          Karggu es más que un TMS, es una solución completa de principio a fin.
        </p>
      </div>

      {/* Tarjetas */}
      <div className="flex flex-col lg:flex-row gap-8 w-full max-w-6xl mt-2 lg:mt-20">
        <div className="flex-1 bg-white p-8 rounded-2xl shadow-lg">
          <div className="mb-4">
            <p className="text-[#ea1300] font-semibold text-5xl text-center">100%</p>
            <p className="text-[#ea1300] text-xl text-center font-medium mt-2">
              Control de tu empresa
            </p>
          </div>
          <p className="text-gray-700 text-center text-[98%] font-medium">
            Visibilidad total y control en tiempo real, podrás tomar mejores decisiones, 
            atender más clientes y crecer sin perder el control.
          </p>
        </div>

        <div className="flex-1 bg-white p-8 rounded-2xl shadow-lg">
          <div className="mb-4">
            <p className="text-[#ea1300] font-semibold text-5xl text-center">40%</p>
            <p className="text-[#ea1300] text-xl text-center font-medium mt-2">
              Ahorro en procesos
            </p>
          </div>
          <p className="text-gray-700 text-center text-[98%] font-medium">
            Automatizamos tareas manuales, eliminamos errores y reducimos tiempos muertos. 
            Así o más fácil el crecer sin gastar de más.
          </p>
        </div>

        <div className="flex-1 bg-white p-8 rounded-2xl shadow-lg">
          <div className="mb-4">
            <p className="text-[#ea1300] font-semibold text-5xl text-center">100%</p>
            <p className="text-[#ea1300] text-xl text-center font-medium mt-2">
              Optimización en carta porte
            </p>
          </div>
          <p className="text-gray-700 text-center text-[98%] font-medium">
            Desde el pedido hasta la entrega final, tu flujo sin trabas y con la información 
            para generar tu carta porte sin problema en un sólo lugar.
          </p>
        </div>
      </div>
    </div>
  )
}